import { render, staticRenderFns } from "./CartChoView.vue?vue&type=template&id=6bcbd9d6&"
import script from "./CartChoView.vue?vue&type=script&lang=js&"
export * from "./CartChoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports